import React, {Component} from 'react';
import TextFieldGroup from '../common/TextFieldGroup';
import { connect } from 'react-redux';
import { login } from '../../actions';
import styled from 'styled-components';
//import LogoImg from './examiner_logo.png';
import LogoImg from '../../assets/img/bicam_logo.svg';
import CorpLogoImg from './rh_logo.png';
import NormalImg from '../common/Img';
import Form from '../common/Form';
import Button from '../common/Button';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import loginValidation from '../../utils/loginValidation';

const Img = styled(NormalImg)`
  width: 275px;
  display: inline-block;
  margin: 25px auto 0 auto;
`;

const RhLogo = styled(NormalImg)`
  width: 150px;
  margin: 0 auto 20px auto;
  display: block;
`;

const externalLink = {
  color: '#fff',
};

class LoginForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      email: '',
      pw: '',
      errors: {},
      isLoading: false,
      done: false,
      globalError: ''
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  isValid(){
    const { errors, isValid } = loginValidation(this.state);

    if(!isValid){
      this.setState({errors});
    }

    return isValid;
  }
  onSubmit(e){
    e.preventDefault();
    if(this.isValid()){
      this.setState({errors: {}, isLoading: true});
      this.props.login(this.state).then(
        (res) => this.setState({done: true}),
        (err) => this.setState({globalError: "The email address and password you entered do not match, please tray again", isLoading: false})
      );
    }
  }
  onChange(e){
    this.setState({ [e.target.name]: e.target.value });
  }
  render() {
    const { errors, email, pw, isLoading } = this.state;
    const form = (
      
        <div className="text-center">
          <Img src={LogoImg} alt="Examiner App Logo" />
          
          {!!this.state.globalError && <div className="alert alert-danger"><p>{this.state.globalError}</p></div>}
          <Form>
            <h3>Sign In</h3>
            <div>
              <TextFieldGroup
                field="email"
                type="email"
                placeholder="Email Address"
                value={email}
                error={errors.email}
                onChange={this.onChange}
              />
              <TextFieldGroup
                field="pw"
                placeholder="Password"
                value={pw}
                error={errors.pw}
                onChange={this.onChange}
                type="password"
              />
              <Link to="/sdmt_test"><Button disabled={isLoading} className="btn btn-lg">Login</Button></Link><br />
              <p className="text-right"><a style={externalLink} href="https://www.bicams.net/password-recovery.aspx">Forgot yout password?</a></p>
            </div>
          </Form>
          <footer>
            <RhLogo src={CorpLogoImg} alt="Royal Holloway Logo" />
            <p>This software is designed to offer a convenient way to provide a preliminary indication of cognition in MS patients. It is designed to be used by qualified health professionals. It is not a medical or clinical technology and is not a diagnostic tool. </p>
          </footer>
        </div>
      
    );
    return (
      <div>
        {this.state.done ? <Redirect to='/sdmt_test' /> : form}
      </div>
    );
  }
}

LoginForm.propTypes = {
  login: React.PropTypes.func.isRequired
}

LoginForm.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default connect(null, {login})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js